module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600-693057428838523377f5c2da26f44899.eot";